export const comments_3249784 = {"data":{"data":[],"links":{}}}